import React from 'react';
import InventoryItem from './InventoryItem.react';
import cx from 'classnames';
import moment from 'moment';
import { Tooltip } from 'react-bootstrap';
import { OverlayTrigger } from 'react-bootstrap';
import { numberWithCommas } from '../../utils/helpers';
import _ from 'underscore';
var AuthStore = require("../../stores/AuthenticationStore");

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openInventoryId: null
    };
  }

  render() {
    const toggleOpen = (key) => {
      const open = this.state.openInventoryId === key;
      const id = open ? null : key;
      this.setState({ openInventoryId: id });
    }

    let statusClasses = cx({
      'in-use'      : this.props.equipment.status === '8ee7ff88-4c91-43ee-9a56-b1e7e93ebebd',
      'in-storage'  : this.props.equipment.status === 'e9261d6c-35a2-4924-b4d0-91790a266263',
      'for-sale'    : this.props.equipment.status === '48df1cf3-481b-4daf-a68d-3b5abde83470' ||
                      this.props.equipment.status === 'For sale within account' ||
                      this.props.equipment.status === 'For sale to anybody' ||
                      this.props.equipment.status === 'For sale to account employees',
      'sold'        : this.props.equipment.status === 'aaa5b8aa-209a-4b62-98fd-cafb9706c57d',
      'deleted'     : this.props.equipment.status === '87486fe0-6718-407f-846f-9fdb7f1e0ee4',
      'disposed'    : this.props.equipment.status === 'e44e0d1e-b911-4756-be36-2bac339fe360',
      'given'       : this.props.equipment.status === '8b0989db-1251-4843-82e1-c50323e7d227',
    });

    if (this.props.quanity && this.props.quanity > 1) {
      statusClasses = 'group';
    }

    var price = 0;
    var itemsInsured = 0;

    _.map(this.props.group, function(item){
      price += parseInt(item.purchase_price);
      if(item.insured) {
        itemsInsured +=1;
      }
    });
    if (price === 0) {
      price = this.props.equipment.purchase_price;
    }

    let insureSelector = cx({
      'insure-selector': true,
      'selected': _.has(this.props.selectedEquipmentToInsure, this.props.equipment.id)
    });

    //check if the user has role for the equipment
    var allowEdit = false;
    var allowDelete = false;
    if(statusClasses !== 'group'){
      const userData = AuthStore.getState();
      if(this.props.equipment) {
        if(this.props.equipment.required_role){
          //if the equipment has role
          allowEdit = false;
          for (let i = 0; i < userData.roles.length; i++) {
            if (userData.roles[i] === this.props.equipment.required_role) {
              allowEdit = true;
              allowDelete = true;
            }
          }
        } else {
          // check if user has access to department
          var department_access = userData.access[this.props.equipment.department];
          //check if the department access is listed under user access and if he has
          //permission to edit we allow him to edit
          if(department_access && department_access >= 3) {
            allowEdit = true;
          }
          if(department_access && department_access >= 4) {
            allowDelete = true;
          }
        }
      }
    } else {
      allowEdit = true;
    }



    return (
      <div
        className={
          `equipment-list-item-wrapper
          ${this.props.open     ? ' open'   : ''}
          ${this.props.isHidden ? ' hidden' : ''}
          ${(this.props.quanity && this.props.quanity > 1) ? ' group' : ''}`
        }
      >
        <div className='equipment-list-item-content'>
          <div
            className={
              `equipment-list-item
              ${(this.props.quanity && this.props.quanity > 1) ? ' group' : ''}
              ${!allowEdit ? ' uneditable' : ''}`}
            onClick={this.props.toggleOpen}
          >
            {(this.props.quanity && this.props.quanity > 1) ?
              <div className='eq eq-status'>
                <div
                  title={this.props.equipment.status_text ? this.props.equipment.status_text : ''}
                  className={statusClasses}
                >
                  {(this.props.quanity && this.props.quanity > 1) && this.props.quanity}
                </div>
              </div>
            :
              <OverlayTrigger
                placement='left'
                overlay={
                  <Tooltip id={this.props.id}>
                    {this.props.equipment.status_text}
                  </Tooltip>
                }>

                <div className='eq eq-status'>
                  <div
                    title={this.props.equipment.status_text ? this.props.equipment.status_text : ''}
                    className={statusClasses}
                  >
                    {(this.props.quanity && this.props.quanity > 1) && this.props.quanity}
                  </div>
                </div>
              </OverlayTrigger>
            }

            <div className='eq eq-brand'>{this.props.equipment.brand_name ? this.props.equipment.brand_name : ''}</div>
            <div className='eq eq-title'>{this.props.equipment.name}</div>
            <div className='eq eq-type hidden-sm'>{this.props.equipment.type_name ? this.props.equipment.type_name : ''}</div>
            <div className='eq eq-loc hidden-sm'>
              {this.props.equipment.location_name ? this.props.equipment.location_name : ''}
            </div>
            <div className='eq eq-date hidden-sm'>{moment(this.props.equipment.creation_date).format('DD MMM YYYY')}</div>
            <div className='eq eq-date hidden-sm'>{moment(this.props.equipment.purchase_date).format('DD MMM YYYY')}</div>
            <div className='eq eq-price'>{numberWithCommas(parseInt(price))+' kr.'}</div>
            {(allowEdit) ?
            <div className="eq eq-readable"></div>
            :
            <div className="eq eq-readable">
              <span className="glyphicon glyphicon-eye-open"></span>
            </div>
            }
            <div className='eq eq-checkbox'>
            {(this.props.quanity && this.props.quanity > 1 && itemsInsured > 0) &&
              <span className="insured-group">
                <span className="fas fa-shield-check insurance-active" />
                {(itemsInsured != this.props.quanity) &&
                  <small className="insured-group-count"> {itemsInsured}/{this.props.quanity}</small>
                }
              </span>
            }
            {(allowEdit && this.props.quanity && this.props.quanity === 1 && !this.props.equipment.insured) &&
              <span className={insureSelector} onClick={(e) => { e.stopPropagation(); this.props.addEquipmentToInsurance(this.props.equipment) }}>
                <div className="insured-group ">
                  <span className="far fa-shield-check insurance-inactive" />
                </div>
              </span>
            }
            {(allowEdit && this.props.quanity && this.props.quanity === 1 && this.props.equipment.insured) &&
              <span className={insureSelector} onClick={(e) => { e.stopPropagation(); this.props.uninsureEquipment(this.props.equipment)} } >
                <div className="insured-group ">
                  <span className="fas fa-shield-check insurance-active" />
                </div>
              </span>
            }
            </div>
          </div>
          {(this.props.open && !this.props.isMarket) &&
            <div className="actions">
              {(allowEdit) &&
              <button
                className="btn btn-md btn-default pull-right sell"
                type="button"
                title="Bæta við byggt á þessum hlut"
                onClick={this.props.openSell}
              >
                <span className="md md-attach-money" />
                <span className="button-text">Selja</span>
              </button>
              }
              {(allowEdit && !this.props.equipment.insured) &&
              <button
                className="btn btn-md btn-default pull-right sell"
                type="button"
                title="Bæta við byggt á þessum hlut"
                onClick={(e) => { e.stopPropagation(); this.props.insureSpecificEquipment(this.props.equipment); }}
              >
                <span className="md md-verified-user" />
                <span className="button-text">Tryggja</span>
              </button>
              }
              {(allowEdit) &&
              <button
                className="btn btn-md btn-default pull-right"
                type="button"
                title="Bæta við byggt á þessum hlut"
                onClick={this.props.openAdd}
              >
                <span className="md md-content-copy" />
                <span className="button-text">Fjölga</span>
              </button>
              }
              {(allowEdit) &&
              <button
                className="btn btn-md btn-default pull-right edit"
                type="button"
                title="Breyta"
                onClick={this.props.openEdit}
              >
                <span className="md md-mode-edit" />
                <span className="button-text">Breyta</span>
              </button>
              }

              {(allowDelete) &&
              <button
                className="btn btn-md btn-default pull-right delete"
                type="button"
                title="Eyða"
                onClick={this.props.openDelete}
              >
                <span className="md md-delete" />
                <span className="button-text">Eyða</span>
              </button>
              }
            </div>
          }
        </div>
        {(this.props.open && this.props.group.length <= 1) &&
          <InventoryItem
            equipment={this.props.equipment}
            forId={this.props.id}
            allowEdit={allowEdit}
            allowDelete={allowDelete}
            isMarket={this.props.isMarket}
          />
        }
        {(this.props.open && this.props.group.length > 1) &&
          this.props.group.map((item, key) => {
            return (
              <div key={key}>
                <Item
                  id={key}
                  toggleOpen={() => toggleOpen(key)}
                  equipment={item}
                  open={
                    (this.state.openInventoryId === key) ? true : false
                  }
                  isHidden={false}
                  openDelete={this.props.openDelete}
                  openEdit={(e) => this.props.openEdit(e, key)}
                  openAdd={this.props.openAdd}
                  quanity={1}
                  group={[]}
                  selectedEquipmentToInsure={this.props.selectedEquipmentToInsure}
                  addEquipmentToInsurance={this.props.addEquipmentToInsurance}
                  uninsureEquipment={this.props.uninsureEquipment}
                  insureSpecificEquipment={this.props.insureSpecificEquipment}
                />
              </div>
            );
          })
        }
      </div>
    );
  }
};

export default Item;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/Item.react.js